module.exports = __webpack_public_path__ + "img/icon-app-apple.81e64ca.webp";